import { render, staticRenderFns } from "./Location2Picker.vue?vue&type=template&id=23b25fcb&"
import script from "./Location2Picker.vue?vue&type=script&lang=ts&"
export * from "./Location2Picker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports